import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import { getI18n } from 'client/i18n'
import TransferReviewBox from '../transfer_review_box'
import StandardError from 'components/common/standard_error'
import styles from './delete_review.less'

const i18n = getI18n('components/edit_glimpse/edit_delete')

class DeleteReview extends React.Component {
  static propTypes = {
    campaignId: PropTypes.string.isRequired,
    moneyBoxAmount: PropTypes.number,
    onDelete: PropTypes.func.isRequired,
    error: PropTypes.any,
  }

  componentDidMount() {
    if (!this.props.moneyBoxAmount) {
      this.props.onDelete()
    }
  }

  render() {
    if (this.props.error) {
      return (
        <StandardError
          iconType="error"
          title={i18n('delete_error')}
          onTryAgain={this.props.onDelete}
          showButton
        />
      )
    }

    if (!this.props.moneyBoxAmount) {
      return null
    }

    return (
      <div>
        <div styleName="title">{i18n('review_title')}</div>
        <TransferReviewBox campaignId={this.props.campaignId} />
        <button
          data-pa-click="delete"
          className="vx_btn vx_btn-block"
          onClick={this.props.onDelete}
          styleName="delete-button"
        >
          {i18n('review_delete_action')}
        </button>
      </div>
    )
  }
}

export default cssModules(DeleteReview, styles)
